// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2_GQr","head":"Table_head__3imfH","col":"Table_col__1zFbU"};